import type { MouseEvent } from 'react';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import RwIconButton from '@/common/presentation/components/rw/RwIconButton';

/** Show/hide toggle for a quote canvas row, group or line. `pressed` = the item is currently visible. */
export function CanvasEyeButton({ label, pressed, onToggle }: { label: string; pressed: boolean; onToggle: () => void }) {
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    // The host canvas selects a block on click; toggling a row must not.
    event.stopPropagation();
    onToggle();
  };
  return (
    <RwIconButton size="sm" aria-label={label} aria-pressed={pressed} data-canvas-affordance="eye" onClick={handleClick}>
      {pressed ? <VisibilityOutlinedIcon fontSize="small" aria-hidden /> : <VisibilityOffOutlinedIcon fontSize="small" aria-hidden />}
    </RwIconButton>
  );
}
